import React, { useState, useEffect } from 'react'
import Layout from '../../layout'
import Swal from 'sweetalert2'
import Loader from '../../components/common/loader'
import Breadcrums from '../../components/common/breadcrumbs'
import { formateDate } from '../../helpers/commonFunctions'
import {
    ListAppBuilds,
    DownloadAppBuild,
    DeleteAppBuild,
    SetAppBuildApproval,
} from '../../services/appBuildService'

const PLATFORMS = ['android', 'windows']
const BUILD_TYPES = ['cashier', 'kitchen']

const AppBuildsList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "App Builds", url: "" }]
    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [loader, setLoader] = useState(true)
    const [page, setPage] = useState(1)
    const [perPage] = useState(20)
    const [platform, setPlatform] = useState('')
    const [buildType, setBuildType] = useState('')
    const [refreshFlag, setRefreshFlag] = useState(false)

    useEffect(() => {
        setLoader(true)
        const payload = { page, per_page: perPage }
        if (platform) payload.platform = platform
        if (buildType) payload.build_type = buildType
        ListAppBuilds(payload).then(data => {
            const body = data?.data?.response || {}
            setList(Array.isArray(body.rows) ? body.rows : [])
            setCount(Number(body.count) || 0)
            setLoader(false)
        }).catch(error => {
            console.log("list builds error ====> ", error)
            setLoader(false)
        })
    }, [page, perPage, platform, buildType, refreshFlag])

    const showToast = (icon, title) => {
        Swal.fire({
            customClass: 'swal-wide',
            icon,
            title,
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top-right',
        })
    }

    const handleDownload = async (id, filename) => {
        try {
            const response = await DownloadAppBuild(id)
            const blob = new Blob([response.data])
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = filename || `build-${id}`
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
        } catch (err) {
            console.log("download error ====> ", err)
            showToast('error', err?.response?.data?.message || 'Failed to download build')
        }
    }

    const handleDelete = (id) => {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Delete this build?',
            text: 'This will permanently remove the file and database record.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#403fad',
            confirmButtonText: 'Yes, delete!',
        }).then((result) => {
            if (!result.isConfirmed) return
            DeleteAppBuild(id).then(() => {
                showToast('success', 'Build deleted successfully')
                setRefreshFlag(!refreshFlag)
            }).catch(err => {
                console.log("delete error ====> ", err)
                showToast('error', err?.response?.data?.message || 'Failed to delete build')
            })
        })
    }

    const handleApproval = (id, isApproved) => {
        Swal.fire({
            customClass: 'swal-wide',
            title: isApproved ? 'Approve this build?' : 'Reject this build?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#403fad',
            cancelButtonColor: '#f1388b',
            confirmButtonText: isApproved ? 'Yes, approve!' : 'Yes, reject!',
        }).then((result) => {
            if (!result.isConfirmed) return
            SetAppBuildApproval(id, isApproved).then(() => {
                showToast('success', isApproved ? 'Build approved' : 'Build rejected')
                setRefreshFlag(!refreshFlag)
            }).catch(err => {
                console.log("approval error ====> ", err)
                showToast('error', err?.response?.data?.message || 'Failed to update approval')
            })
        })
    }

    const totalPages = Math.max(1, Math.ceil(count / perPage))

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card overflow-hidden">
                    <div className="card-body">
                        <div className='d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2'>
                            <h6 className="main-content-label mb-0">App Builds</h6>
                            <div className="d-flex align-items-center gap-2">
                                <label className="me-2 mb-0">Application:</label>
                                <select
                                    className="form-control"
                                    style={{ width: '160px' }}
                                    value={buildType}
                                    onChange={(e) => { setBuildType(e.target.value); setPage(1); }}
                                >
                                    <option value="">All</option>
                                    {BUILD_TYPES.map((b) => (
                                        <option key={b} value={b}>{b.charAt(0).toUpperCase() + b.slice(1)}</option>
                                    ))}
                                </select>
                                <label className="me-2 mb-0">Platform:</label>
                                <select
                                    className="form-control"
                                    style={{ width: '160px' }}
                                    value={platform}
                                    onChange={(e) => { setPlatform(e.target.value); setPage(1); }}
                                >
                                    <option value="">All</option>
                                    {PLATFORMS.map((p) => (
                                        <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>
                                    ))}
                                </select>
                                <button className="btn ripple btn-secondary ms-2" onClick={() => { setBuildType(''); setPlatform(''); setPage(1); }}>Reset</button>
                                <button className="btn ripple btn-main-primary signbtn ms-2" onClick={() => setRefreshFlag(!refreshFlag)}>Refresh</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th width="6%">S.No</th>
                                        <th width="7%">Application</th>
                                        <th width="6%">Build No</th>
                                        <th width="7%">Version</th>
                                        <th width="7%">Platform</th>
                                        <th width="22%">Filename</th>
                                        <th width="7%">Approved</th>
                                        <th width="10%">Created At</th>
                                        <th className='action_head' width="18%">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={8}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr key={row.id || i}>
                                                    <td>{((page - 1) * perPage) + i + 1}</td>
                                                    <td>{String(row.build_type).toUpperCase() ?? '-'}</td>
                                                    <td>{row.build_no ?? '-'}</td>
                                                    <td>{row.version_name || row.version || '-'}</td>
                                                    <td>{row.platform ? row.platform.charAt(0).toUpperCase() + row.platform.slice(1) : '-'}</td>
                                                    <td style={{ whiteSpace: 'normal', wordBreak: 'break-all', maxWidth: '300px' }}>{row.filename || '-'}</td>
                                                    <td>
                                                        {row.is_approved ?
                                                            <span className="badge bg-success">Yes</span> :
                                                            <span className="badge bg-secondary">No</span>}
                                                    </td>
                                                    <td>{row.created_at ? formateDate(row.created_at) : '-'}</td>
                                                    <td>
                                                        <div className="d-flex flex-wrap gap-1">
                                                            <button className="btn btn-sm btn-main-primary signbtn" style={{ minWidth: '80px' }} onClick={() => handleDownload(row.id, row.filename)}>Download</button>
                                                            {row.is_approved ?
                                                                <button className="btn btn-sm btn-warning" style={{ minWidth: '80px' }} onClick={() => handleApproval(row.id, false)}>Reject</button> :
                                                                <button className="btn btn-sm btn-success" style={{ minWidth: '80px' }} onClick={() => handleApproval(row.id, true)}>Approve</button>
                                                            }
                                                            <button className="btn btn-sm btn-danger" style={{ minWidth: '80px' }} onClick={() => handleDelete(row.id)}>Delete</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr><td colSpan={8} className="text-center">No builds found</td></tr>}
                                        </>}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div role="status" aria-live="polite"><b>Total Records: {count}</b></div>
                            {count > perPage && (
                                <div className="d-flex align-items-center gap-2">
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={page <= 1}
                                        onClick={() => setPage(page - 1)}
                                    >Prev</button>
                                    <span>Page {page} of {totalPages}</span>
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={page >= totalPages}
                                        onClick={() => setPage(page + 1)}
                                    >Next</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default AppBuildsList


